var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"main-container"},_vm._l((_vm.rows),function(row,idx){return _c('b-row',{key:idx},_vm._l((row),function(item){return _c('b-col',{key:item.id,staticClass:"photo-block-main"},[_c('div',{staticClass:"photo-block",style:(item.thumbStyle)},[_c('div')])])}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6eb0c88","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = ROzN
// module chunks = 1